import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M13 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5","key":"svg-1"}]]

const IconNumber13Small = createReactComponent('outline', 'number-13-small', 'Number13Small', __iconNode);

export default IconNumber13Small;